import { adminHttpClient } from '../../../commons/adminHttpClient'

export type ResendRenewalNoticeRequest = {
    companyUserId: string
    planPeriodId: string
}

const resendRenewalNotice = (request: ResendRenewalNoticeRequest): Promise<void> => {
    return adminHttpClient.post(`/InvitePeople/RenewalNotification`, request)
}

export default resendRenewalNotice